import styled from 'styled-components';
import { Modal } from '@marriott/mi-ui-library';

export const StyledUpdateEventStateModal = styled(Modal)`
  .confirm-cta {
    width: auto;
  }
`;
